import { ADMIN_ACCOUNT_TYPE } from '../../../constants/Config';
import BaseConstantSelectBox from '../../components/BaseConstantSelectBox';

class AdminAccountTypeSelectBox extends BaseConstantSelectBox {
    constructor(props) {
        super(props);

        this.initData = ADMIN_ACCOUNT_TYPE;
    }

    onDataChanged(e) {
        if (e.value !== null) {
            const { field } = this.props;

            this.props.updateData({
                [field]: e.value
            });
        }
        if (e.value === null) {
            const { field } = this.props;

            this.props.updateData({
                [field]: ''
            });
        }
    }
}

export default AdminAccountTypeSelectBox;
